import { defineField, defineType } from 'sanity'
import { RiQuestionnaireLine } from 'react-icons/ri'
import getPageInfo, { seoGroup } from '../../objects/pageInfo'

export default defineType({
  name: 'customerSupport',
  title: 'Customer Support',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    getPageInfo({ path: '', lockCanonical: true }),
    defineField({
      title: 'Hero',
      name: 'hero',
      type: 'hero',
      group: 'content',
    }),
    defineField({
      name: 'questionListSubtitle',
      title: 'Question List Subtitle',
      type: 'string',
      group: 'content',
    }),
    defineField({
      name: 'questionList',
      title: 'Question List',
      type: 'array',
      of: [
        {
          name: 'questionItem',
          type: 'object',
          icon: RiQuestionnaireLine,
          fields: [
            defineField({
              name: 'question',
              title: 'Question',
              type: 'string',
              validation: (rule) => [rule.required()],
            }),
            defineField({
              name: 'url',
              title: 'URL',
              type: 'url',
              validation: (rule) => [
                rule.uri({
                  scheme: ['http', 'https'],
                }).required(),
              ],
              description: 'URL linking to the Zendesk support article',
            }),
          ],
        },
      ],
      group: 'content',
    }),
    defineField({
      name: 'supportSections',
      title: 'Support Sections',
      type: 'array',
      of: [
        {
          type: 'object',
          name: 'supportSectionItem',
          fields: [
            defineField({
              name: 'subtitle',
              title: 'Subtitle',
              type: 'string',
            }),
            defineField({
              name: 'topicList',
              title: 'Topic List',
              type: 'array',
              of: [
                {
                  name: 'topic',
                  title: 'Topic',
                  type: 'object',
                  fields: [
                    defineField({
                      name: 'title',
                      title: 'Title',
                      type: 'string',
                      validation: (rule) => [rule.required()],
                    }),
                    defineField({
                      name: 'shortInfo',
                      title: 'Short Info',
                      type: 'text',
                      validation: (rule) => [rule.required()],
                    }),
                    defineField({
                      name: 'link',
                      title: 'Link',
                      type: 'link',
                      description:
                        'If Link Title matches any part of the Short Info, it will be highlighted on the website',
                    }),
                    defineField({
                      name: 'icon',
                      title: 'Icon',
                      type: 'image',
                      options: {
                        hotspot: true,
                      },
                    }),
                  ],
                },
              ],
              validation: (rule) => [rule.required()],
            }),
          ],
        },
      ],
      group: 'content',
    }),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})